import React from 'react';
import {nanoid} from 'nanoid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {CategoryItem} from '../../QCTools/QCToolsMetadata/QCToolsMetadataTypes';
import {HandleChangeSelectType} from '../../QCWorkflow/QCManager/QCManagerTypes';

interface SubCategoriesContainerProps {
    categoryLabel: string,
    subCategoryLabel: string,
    onChange: HandleChangeSelectType;
    data: CategoryItem[] | null;
}

export const SubCategoriesContainer = (props: SubCategoriesContainerProps) => {
    const {
        categoryLabel,
        subCategoryLabel,
        onChange,
        data,
    } = props;
    
    const subCategories = getOptions(data, categoryLabel);
    const options = subCategories?.map(mapCategoriesToOptions);
    
    return (
        <FormControl>
            <Select
                value={subCategoryLabel}
                onChange={onChange}
            >
                {options}
            </Select>
        </FormControl>
    );
};

export const mapCategoriesToOptions = ({label}: CategoryItem) => {
    return (
        <MenuItem
            key={nanoid()}
            value={label}
        >
            {label}
        </MenuItem>
    );
};

export const getOptions = (categories: CategoryItem[] | null, category: string) => {
    return categories?.find((item: CategoryItem) => item.label === category)?.subCategories;
};
